import { Link } from 'react-router-dom'
import BrandMark from './BrandMark'

/**
 * Rahmen für die eigenständigen Auth-Seiten (Passwort vergessen, zurücksetzen,
 * E-Mail bestätigen). Diese Seiten laufen ohne das normale Layout, brauchen
 * aber dasselbe dunkle Theme.
 */
export default function AuthShell({
  title,
  subtitle,
  children,
}: {
  title: string
  subtitle?: string
  children: React.ReactNode
}) {
  return (
    <div
      className="wc-theme"
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '48px 20px',
      }}
    >
      <div style={{ width: '100%', maxWidth: 440 }}>
        <Link
          to="/"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 8,
            textDecoration: 'none',
            color: 'var(--wc-text)',
            fontSize: 16,
            marginBottom: 28,
          }}
        >
          <BrandMark size={18} />
          Werkstatt-Connect
        </Link>

        <div className="wc-card wc-elev-sm" style={{ padding: 28, gap: 18 }}>
          <div>
            <h1 style={{ fontSize: 25, margin: 0 }}>{title}</h1>
            {subtitle && (
              <p className="wc-muted" style={{ fontSize: 14, margin: '8px 0 0' }}>
                {subtitle}
              </p>
            )}
          </div>
          {children}
        </div>
      </div>
    </div>
  )
}
